module.exports = __webpack_public_path__ + "static/img/presysv72.fa7e23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv72.png
// module id = o3vM
// module chunks = 1